// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"b75de3e7","456":"d519aa3b","578":"49bc9b41","703":"6c523c58","705":"411c793a","722":"4f5e33b0","778":"585cd20b"}[chunkId] + ".chunk.js";
};